import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'

type ReturnType = string | null | boolean | number | string[]

export const defaultValue = (fieldType: string): ReturnType => {
  switch (fieldType) {
    case FieldTypes.money:
    case FieldTypes.cents:
    case FieldTypes.date:
      return null

    case FieldTypes.checkbox:
      return false

    case FieldTypes.multipleChoice:
      return []

    default:
      return ''
  }
}
